import { Component, OnInit } from '@angular/core';
import { AuthService } from 'services/auth/auth.service';
import { UserInfoService } from 'services/user-info/user-info.service';
import swal from 'sweetalert2';

const pack = require('../../../package.json');

declare var $: any;

export interface RouteInfo {
	path: string;
	title: string;
	icon: string;
	class: string;
}

export const ROUTES: RouteInfo[] = [
	{ path: 'display', title: 'DMS Overview', icon: 'ti-eye', class: '' },
	{ path: 'control', title: 'DMS Control', icon: 'ti-blackboard', class: '' },
	{ path: 'weigh-station', title: 'Weigh Stations', icon: 'ti-blackboard', class: '' },
	//{ path: 'dashboard', title: 'Dashboard',  icon: 'ti-panel', class: '' },
	{ path: 'profile', title: 'User Profile', icon: 'ti-user', class: '' },
	// {
	// 	path: 'log',
	// 	title: 'DMS Log',
	// 	icon: 'ti-view-list-alt',
	// 	class: 'desktop-only admin-only'
	// },
	{
		path: 'requests',
		title: 'Message Requests',
		icon: 'ti-view-list',
		class: 'desktop-only admin-only'
	},
	{
		path: 'activity',
		title: 'Activity Log',
		icon: 'ti-view-list-alt',
		class: 'desktop-only admin-only'
	},
	{
		path: 'users',
		title: 'User List',
		icon: 'ti-agenda',
		class: 'desktop-only admin-only'
	}
	// { path: '', title: 'Questions? Give Feedback!', icon: 'ti-view-list', class: 'desktop-only' }
	// { path: 'login', title: 'Login',  icon:'ti-user', class: '' },
	//{ path: 'typography', title: 'Typography',  icon:'ti-text', class: '' },
	//{ path: 'icons', title: 'Icons',  icon:'ti-pencil-alt2', class: '' },
	//{ path: 'maps', title: 'Maps',  icon:'ti-map', class: '' },
	//{ path: 'notifications', title: 'Notifications',  icon:'ti-bell', class: '' },
	// { path: 'upgrade', title: 'Upgrade to PRO',  icon:'ti-export', class: 'active-pro' },
];

@Component({
	moduleId: module.id,
	selector: 'sidebar-cmp',
	styleUrls: ['sidebar.component.css'],
	templateUrl: 'sidebar.component.html'
})
export class SidebarComponent implements OnInit {
	version = pack.version;
	/**
	 *
	 */
	constructor(public authService: AuthService, private userInfoService: UserInfoService) {}
	public menuItems: any[];
	ngOnInit() {
		this.userInfoService.getValue(this.authService.currentUser.username).subscribe((results) => {
			let userLevel = results[0].user_level;
			let isAdmin = userLevel === 1;
			this.menuItems = ROUTES.filter((menuItem) => {
				let onlyDesktop = menuItem.class.includes('desktop-only');
				let onlyAdmin = menuItem.class.includes('admin-only');
				// console.log(menuItem.title,' isAdmin:', isAdmin, 'onlyDesktop:', onlyDesktop, 'onlyAdmin:', onlyAdmin, 'isMobile:', this.isMobile());
				return (!this.isMobile() || !onlyDesktop) && (isAdmin || !onlyAdmin);
			});
		});
	}
	isMobile() {
		if ($(window).width() > 991) {
			return false;
		}
		return true;
	}

	async sendFeedback() {
		const { value: text } = await swal({
			input: 'textarea',
			title: 'Have an idea or question? Please tell us, we are here to help',
			inputPlaceholder: 'Type your comment here. Compliments are welcome',
			showCancelButton: true
		});

		if (text) {
			//   swal(text);
			this.userInfoService.create({ message: text }).subscribe((res) => {
				swal('Thank you for your feedback!');
			});
			// console.log(text);
		}
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/sidebar/sidebar.component.ts